import fancybox from '@fancyapps/fancybox';

$('[data-teaser]').fancybox({
    toolbar: false,
    smallBtn: true,
    youtube: {
        controls: 0,
        showinfo: 0,
        autoplay: 1,
    },
    // baseTpl:
    //     '<div class="fancybox-container fancybox-teaser" role="dialog" tabindex="-1">' +
    //         '<div class="fancybox-bg"></div>' +
    //         '<div class="fancybox-inner">' +
    //             '<div class="fancybox-stage">' +
    //             '</div>' +
    //         '</div>' +
    //     '</div>',
});



// WEBPACK FOOTER //
// ./src/js/features/teaserVideo.js